var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ 'min-width': !_vm.$route.meta.nozoom ? '1300px' : '0px' }),attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"}},[_vm._v("聂章帅")]),_c('div',{style:({ zoom: !_vm.$route.meta.nozoom ? 0.8 : 1 }),attrs:{"id":"app1"}},[(
          !_vm.$route.meta.noShowHeader &&
          (!_vm.$route.query.type ||
            _vm.$route.query.type == 1 ||
            _vm.$route.path == '/registName') &&
          _vm.cityDetail.cityName == '新乡市平原城乡一体化示范区'
        )?_c('PYXQHead'):(
          !_vm.$route.meta.noShowHeader &&
          (!_vm.$route.query.type ||
            _vm.$route.query.type == 1 ||
            _vm.$route.path == '/registName')
        )?_c('Head'):_vm._e(),(!_vm.$route.meta.noShowHeader)?_c('div',{staticClass:"maincontent",staticStyle:{"z-index":"1"}},[_c('div',{staticClass:"minHeight",staticStyle:{"min-height":"630px"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(_vm.cityDetail.cityName == '濮阳市')?_c('PYSFoot'):_c('Foot')],1):_vm._e(),(_vm.$route.meta.noShowHeader)?_c('router-view',{on:{"initWebSocket":_vm.initWebSocket}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }